module.exports = __webpack_public_path__ + "static/media/1-1.ce43df82.svg";